import { useDateLocale } from "core/hooks/useDateLocale";
import { useGetOntology } from "core/model/utils/ontologies/hooks";
import { Auction, AuctionRequest } from "core/types";
import { useEncryption } from "dsl/atoms/Contexts";
import { usePrintWindow } from "dsl/atoms/PrintButton";
import { StaticPatientProfile } from "dsl/static/StaticPatientProfile";
import { useLocale, useTranslations } from "translations";

export function PatientProfilePrint({
  auction,
  auctionRequest,
  isForClinic,
}: {
  auction: Auction;
  auctionRequest?: AuctionRequest;
  isForClinic?: boolean;
}) {
  usePrintWindow();
  const { currentLocale } = useDateLocale();
  const getOntology = useGetOntology();
  const locale = useLocale();
  const translations = useTranslations();
  const { isSealdOnly, withEncryptionAccess } = useEncryption();

  return (
    <StaticPatientProfile
      auction={auction}
      auctionRequest={auctionRequest}
      currentLocale={currentLocale}
      getOntology={getOntology}
      isForClinic={isForClinic}
      isSealdOnly={isSealdOnly}
      locale={locale}
      translations={translations}
      withEncryptionAccess={withEncryptionAccess}
    />
  );
}
